import isURL from 'validator/lib/isURL';

const url = value => {
    if (typeof value === 'undefined') return undefined;
    if(value === '' || value === null) return undefined;
    const isValid = isURL(value + '');
    return !isValid ? 'Please enter a valid URL' : undefined;
} 
export default url;